import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { Breadcrumbs } from './components/breadcrumbs/breadcrumbs';
import Arrow from './components/arrow/arrow';
import { showSEODescription } from './constants';
import classes from './category-description.scss';
export const CategoryDescription = ({
  isDescriptionBlockShown,
  isDescriptionBlockOpen,
  descriptionTitle,
  descriptionText,
  isFilterPopupOpen,
  withAnimation,
  currentCategory,
  isCuratedBrandStore
}) => {
  const [isDescriptionTextShown, setIsDescriptionTextShown] = useState(false);
  useEffect(() => {
    setIsDescriptionTextShown(currentCategory.isDescriptionShownByDefault);
  }, [currentCategory._id]);
  const isDescriptionTextHidden = !showSEODescription || !isDescriptionBlockOpen && (!descriptionText || !isDescriptionTextShown);
  const showArrow = !isDescriptionBlockOpen && descriptionText && showSEODescription;
  const toggleIsDescriptionTextShown = () => setIsDescriptionTextShown(prev => !prev);
  if (isCuratedBrandStore) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.container, {
      [classes.containerWithOpenedFilterPopup]: isFilterPopupOpen
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames({
      [classes.activeFilter]: isFilterPopupOpen,
      [classes.spacer]: withAnimation
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.content, {
      [classes.emptyCategoryContent]: !isDescriptionBlockShown
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.breadcrumbsContainer
  }, /*#__PURE__*/React.createElement(Breadcrumbs, {
    className: classes.breadcrumbs
  })), showArrow && /*#__PURE__*/React.createElement(Arrow, {
    onClick: toggleIsDescriptionTextShown,
    isShown: isDescriptionTextShown
  }), descriptionTitle && /*#__PURE__*/React.createElement("h1", {
    className: classes.title
  }, descriptionTitle), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.description, {
      [classes.hidden]: isDescriptionTextHidden
    })
  }, descriptionText)));
};